import React, { Suspense, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { setSelectedBuilding } from '../../../redux/selectedBuildingSlice';
import { setSelectedAccount } from '../../../redux/selectedAccountSlice';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box,
  Grid,
  Container,
  CircularProgress,
  Pagination,
  Fade,
} from '@mui/material';
import FilterPanel from './FilterPanel';

import OperationsDetailCard from '@/features/building-optimization-operations-dashboard/components/OperationsDetailCard';

const OperationsDetailPage = () => {
  const { accounts } = useOutletContext();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const itemsPerPage = 16;

  const location = useLocation();

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const dispatch = useDispatch();

  const activeFilter = location.state.activeFilter;

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedBuildings = accounts
    .flatMap((account) => account.Buildings)
    .slice(startIndex, endIndex);

  const handleCardClick = (building) => {
    if (building) {
      const account = accounts.find(
        (account) => account.AccountId === building.AccountId,
      );

      dispatch(setSelectedAccount(account));
      dispatch(setSelectedBuilding(building));

      navigate(`/pvo/buildings/${building.Name}`, {
        state: { building },
      });
    }
  };

  return (
    <Container maxWidth="xxl">
      <FilterPanel activeFilter={activeFilter} />
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <Grid container spacing={4} sx={{ mt: 1 }}>
          {paginatedBuildings.map((building, index) => (
            <Grid item xs={3} key={index}>
              <Fade in={true} timeout={500}>
                <Box>
                  <OperationsDetailCard
                    activeFilter={activeFilter}
                    accounts={accounts}
                    building={building}
                    onCardClick={() => handleCardClick(building)}
                  />
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Suspense>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination
          count={Math.ceil(
            accounts.flatMap((account) => account.Buildings).length /
              itemsPerPage,
          )}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Container>
  );
};

export default OperationsDetailPage;
